<template>
    <span class="rounded-full bg-base-doveGrey px-[10px] py-[6px] sm:px-3">
        <AtomsBody3
            v-if="html"
            :class="
                twMerge(
                    'font-bold text-base-Metal sm:text-[0.875rem]/[1.5]',
                    lg && 'text-[0.875rem]/[1.5]',
                )
            "
            :html="html"
        >
        </AtomsBody3>
        <AtomsBody3
            v-else
            :class="
                twMerge(
                    'font-bold text-base-Metal sm:text-[0.875rem]/[1.5]',
                    lg && 'text-[0.875rem]/[1.5]',
                )
            "
        >
            <slot />
        </AtomsBody3>
    </span>
</template>

<script setup lang="ts">
import { twMerge } from "tailwind-merge";
const { lg = false, html } = defineProps<{ lg?: boolean; html?: string }>();
</script>
